export const commonFunctions = {
  getRequestOptions,
  validateEmail,
  validateConatctNumber,
};

function getRequestOptions(type, extraHeaders, body, bNoToken) {
  let authHeader = {};
  // let userData;
  // if (!bNoToken) {
  //     const currentState = store.getState();
  //     const userInfo = currentState.auth.user;
  //     const accessToken = userInfo ? userInfo.token : null;
  //     authHeader = {
  //         Authorization: `Bearer ${accessToken}`
  //     }
  // }
  // if (bNoToken) {
  //   userData = JSON.parse(localStorage.getItem("userData"));
  //   authHeader = {
  //     "X-JWT-Token": userData.token,
  //   };
  // }

  let requestOptions = {
    method: type,
    headers: {
      ...extraHeaders,
      ...authHeader,
    },
  };
  if (body) {
    requestOptions["body"] = body;
  }
  return requestOptions;
}

function validateConatctNumber(phone) {
  const regex = /^\d{11}$/;
  if (regex.test(phone)) {
    return true;
  } else {
    return false;
  }
}

function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
